import { asyncLoadRouter } from '@router/helper'

const categories = [
  {
    path: 'categories',
    component: asyncLoadRouter('manager/globals/Categories'),
    meta: {
      authorize: ['admin'],
      breadcrumb: (i18n) => [
        {
          text: i18n.t('activerecord.models.category.other'),
          to: { name: 'manager-categories' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-categories',
        component: asyncLoadRouter('manager/globals/categories/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
      {
        path: 'new',
        name: 'manager-categories-new',
        component: asyncLoadRouter('manager/globals/categories/New'),
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('shared.actions.new'),
              to: { name: 'manager-categories-new' },
            },
          ],
        },
        props: { action: 'create' },
      },
      {
        path: ':category_id([A-Za-z\\d]{22})',
        name: 'manager-categories-show',
        component: asyncLoadRouter('manager/globals/categories/Show'),
        redirect: (to) => {
          return {
            name: 'manager-categories-edit',
            params: { category_id: to.params.category_id },
          }
        },
        meta: {
          breadcrumb: (i18n, params) => [
            {
              text: `ID ${params.category_id}`,
              to: {
                name: 'manager-categories-edit',
                params: { category_id: params.category_id },
              },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-categories-edit',
            component: asyncLoadRouter('manager/globals/categories/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
    ],
  },
]

export default categories
